var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"muted":"","autoplay":"","playsinline":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video.fields.file.url,"type":_vm.video.fields.file.contentType}})])}
var staticRenderFns = []

export { render, staticRenderFns }